import { render, staticRenderFns } from "./sorgente.vue?vue&type=template&id=59567382&"
import script from "./sorgente.vue?vue&type=script&lang=js&"
export * from "./sorgente.vue?vue&type=script&lang=js&"
import style0 from "./sorgente.vue?vue&type=style&index=0&id=59567382&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports